/* eslint-disable object-curly-spacing */

import { isValid } from 'redux-form';

export const FORM_NAME = `serviceForm`;
export const syncValidSelector = isValid(FORM_NAME, null, true);

export default function validate(values) {
  const errors = {};

  if (!values.name) {
    errors.name = `Обязательное поле`;
  }
  if (!values.phone) {
    errors.phone = `Укажите, пожалуйста, контактный телефон`;
  }
  if (!values.email) {
    errors.email = `Укажите, пожалуйста, адрес эл. почты`;
  }

  return errors;
}
